import React from 'react';
import { makeStyles } from 'pencil/styles';
import CircularProgress from 'pencil/CircularProgress';
import Typography from 'pencil/Typography';
import * as I18n from 'circe/I18n';
import { fade } from 'pencil/styles/colorManipulator';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: props => ({
    position: 'absolute',
    height: '100%',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column',
    backgroundColor: fade(theme.colors.white, props.overlayOpacity),
    zIndex: 100,
  }),
  circularProgress: {
    margin: '0 auto',
    marginBottom: theme.spacing(1),
  },
}));

const LoadingIndicator = (props) => {
  const classes = useStyles(props);

  const { title = I18n.str('loading', 'Loading...') } = props;

  return (
    <div className={classes.root}>
      <CircularProgress width="100" className={classes.circularProgress} />
      <Typography variant="body2">{title}</Typography>
    </div>
  );
};

LoadingIndicator.defaultProps = {
  overlayOpacity: 0.4,
};

LoadingIndicator.propTypes = {
  overlayOpacity: PropTypes.number,
};

export default LoadingIndicator;
